import React from 'react';
import welcome from '../../img/welcome.png';
const WelcomeSection = () => {
  return (
    <div className="py-5">
      <div className="container mx-auto">
        <div className="md:flex items-center">
          <div className="md:w-1/2 px-8">
            <img src={welcome} alt="" />
          </div>
          <div className="md:w-1/2 p-4">
            <h2>The Best Medical And General Practice Care!</h2>
            <h2 className="text-4xl pt-4 text-main font-bold">
              Improving The Quality Of Your Life Through Better Health.
            </h2>
            <p className="py-4 leading-8 text-xl">
              We believe that improving the quality of your life starts with
              improving your health. We understand that healthy skin is a
              critical component of overall wellness, and we are committed to
              helping our patients achieve healthy, radiant skin that enhances
              their quality of life.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
